/**
 * API de Notificaciones de DamyxIA
 */
import { getBackendUrl } from '../config/api';

const API = getBackendUrl();

export const getNotifications = async (limit = 50, skip = 0, type = null) => {
  const params = new URLSearchParams({ limit, skip });
  if (type) params.append('type', type);
  const res = await fetch(`${API}/api/notifications/list?${params}`, { credentials: 'include' });
  if (!res.ok) throw new Error('Error fetching notifications');
  return res.json();
};

export const getUnreadCount = async () => {
  const res = await fetch(`${API}/api/notifications/unread`, { credentials: 'include' });
  if (!res.ok) throw new Error('Error fetching unread count');
  return res.json();
};

export const markAsRead = async (notificationId) => {
  const res = await fetch(`${API}/api/notifications/mark-read`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ notification_id: notificationId }),
  });
  if (!res.ok) throw new Error('Error marking notification');
  return res.json();
};

export const markAllAsRead = async () => {
  const res = await fetch(`${API}/api/notifications/mark-all-read`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!res.ok) throw new Error('Error marking all');
  return res.json();
};
